import { Component } from 'react'
import PropTypes from 'prop-types'
import { filter } from 'lodash'
import Link from 'components/link'
import SetupGoals from '../setup-goals'
import { SectionHeading } from '../../../components/headings'
import { ldGetFlag } from 'lib/launchDarkly/ldGetFlag'

class RegistrySetup extends Component {
  static propTypes = {
    devicePlatform: PropTypes.string,
    goals: PropTypes.array,
    hasSeenHelloBabyBoxQualified: PropTypes.bool,
    setActiveModal: PropTypes.func,
  }

  state = {
    expanded: false,
  }

  constructor(props) {
    super(props)
    this.onToggleExpandedState = this.onToggleExpandedState.bind(this)
  }

  render() {
    const {
      className,
      devicePlatform,
      goals,
      hasSeenHelloBabyBoxQualified,
      setActiveModal,
      showExtensionInstructions,
      showHeader,
    } = this.props
    const { expanded } = this.state
    const completedCount = filter(
      goals,
      (goal) => goal.state == 'completed'
    ).length
    const goalCount = goals && goals.length
    const remainingCount = goalCount - completedCount

    return (
      <div className={className}>
        <div
          className="flex align-end justify-end"
          style={{ marginBottom: -8 }}
        >
          {showHeader && (
            <div className="flex-grow">
              {remainingCount == 0 ? (
                <span className="h6">😎 Your registry is looking good!</span>
              ) : (
                <>
                  <SectionHeading className="mbs mtn h3">
                    Finish Your Registry Setup
                  </SectionHeading>
                  <span className="h6">
                    <i className="fa fa-icn fa-check text-success" /> You've
                    finished <strong>{completedCount}</strong> of {goalCount}
                  </span>
                </>
              )}
            </div>
          )}

          <Link
            className="h7 toggle-collapse hidden-xs"
            onClick={this.onToggleExpandedState}
          >
            {expanded ? 'See Less' : 'See All'}
          </Link>
        </div>
        <SetupGoals
          devicePlatform={devicePlatform}
          expanded={expanded}
          goals={goals}
          hasSeenHelloBabyBoxQualified={hasSeenHelloBabyBoxQualified}
          setActiveModal={setActiveModal}
          showExtensionInstructions={showExtensionInstructions}
          onToggleExpandedState={this.onToggleExpandedState}
        />
      </div>
    )
  }

  onToggleExpandedState() {
    ldGetFlag('debug-flag', 'control')
    this.setState({ expanded: !this.state.expanded })
  }
}

export default RegistrySetup
